import React from 'react'
import { Produto, TipoAcesso } from '@/core/types/graphql'

interface ProdutoPermissaoLabelProps {
  tiposAcessoByProduto: {
    [key: string]: {
      produto: Produto
      tiposAcesso: TipoAcesso[]
    }
  }
}

export const ProdutoPermissaoLabel = ({
  tiposAcessoByProduto
}: ProdutoPermissaoLabelProps) => {
  const formatNomeTipoAcesso = (nome: string) => {
    if (nome && nome.includes(' - ')) {
      return nome.split(' - ')[0]
    }

    return nome
  }

  return (
    <>
      {Object.entries(tiposAcessoByProduto).map(([, value]) => {
        const { produto, tiposAcesso } = value

        return (
          <span key={produto.id}>
            <span className={'font-bold pr-[3px]'}>{produto.nome}</span>
            <span className={'pr-[5px]'}>
              (
              {[...tiposAcesso].map(
                (tipo, i) =>
                  `${formatNomeTipoAcesso(tipo.nome)}${
                    tiposAcesso.length === i + 1 ? '' : ', '
                  }`
              )}
              )
            </span>
          </span>
        )
      })}
    </>
  )
}
